import { FC, useEffect, useState } from 'react';
import Typography from '@components/common/typography';
import Input from '@components/common/input';
import styles from './styles.module.scss';
import useModalContext from '@hooks/context/useModalContext';
import { useLocales } from '@hooks/helpers/useLocales';
import { IModalComponentProps } from '@context/modal_context';
import { isValidEmail } from '@helpers/validation_objects';
import { TGiftCard, TGiftCardListItem } from '@xeppt/xeppt-sdk/types';
import Radio from '@components/common/radio';
import Phone from '@components/phone';
import { useIsFirstRender } from '@mantine/hooks';

const AddEmailGiftCardModal: FC<
    IModalComponentProps<{
        giftCard: TGiftCard | TGiftCardListItem;
        isEdit: boolean;
        email?: string;
        phone_code?: string;
        phone_number?: string;
    }>
> = ({ modalData, changeModalData }) => {
    const [data, setData] = useState({
        email: '',
        phone_code: '1',
        phone_number: ''
    });
    console.log(data)
    const isFirstRender = useIsFirstRender();
    const { handleChangeDisable } = useModalContext();
    const { validationLocale, labelLocale, placeholderLocale } = useLocales();
    const [recipientNotify, setRecipientNotify] = useState<'email' | 'phone'>('email');

    useEffect(() => {
        if (recipientNotify === 'email') {
            handleChangeDisable(!isValidEmail(data.email));
        } else {
            handleChangeDisable(!data.phone_code || !data.phone_number);
        }
    }, [data, recipientNotify]);

    useEffect(() => {
        if (isFirstRender) {
            setData({
                email: modalData?.giftCard?.email || '',
                phone_code: modalData?.giftCard?.phone_code || '1',
                phone_number: modalData?.giftCard?.phone_number || ''
            });
            if (modalData?.giftCard?.email) {
                setRecipientNotify('email');
            } else if (modalData?.giftCard?.phone_number && modalData?.giftCard?.phone_code) {
                setRecipientNotify('phone');
            }
        }
    }, [modalData, isFirstRender]);

    useEffect(() => {
        changeModalData({ ...modalData, ...data });
    }, [data]);

    return (
        <div className={styles.wrapper}>
            <Typography className={styles.title} variant="h4">
                {!modalData?.isEdit ? 'Add recipient details' : 'Edit recipient details'}
            </Typography>
            <div className={styles.recipient_type_wrapper}>
                <div className={styles.radio_wrapper}>
                    <div className={styles.radio} onClick={() => setRecipientNotify('email')}>
                        <Radio checked={recipientNotify === 'email'} />
                        <Typography>Email address</Typography>
                    </div>
                    <div className={styles.radio} onClick={() => setRecipientNotify('phone')}>
                        <Radio checked={recipientNotify === 'phone'} />
                        <Typography>Phone number</Typography>
                    </div>
                </div>
                <div className={styles.search_wrapper}>
                    {recipientNotify === 'email' ? (
                        <Input
                            full
                            placeholder="Enter email address"
                            label="Recipient email"
                            value={data.email}
                            onChange={(value) => setData((state) => ({ ...state, email: value }))}
                        />
                    ) : (
                        <Phone
                            label="Recipient phone number"
                            isForm={false}
                            phone_code={data.phone_code}
                            phone_number={data.phone_number}
                            onCodeChange={(val) =>
                                setData((state) => ({ ...state, phone_code: val }))
                            }
                            onPhoneChange={(val) =>
                                setData((state) => ({ ...state, phone_number: val }))
                            }
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default AddEmailGiftCardModal;
